module.exports = __webpack_public_path__ + "img/services_corporate.aecaba81.png";